import SegmentedToggle, { SegmentedToggleProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SegmentedToggleProps = {
  children: [
    <SegmentedToggle.Button key="1" value="option">
      Option
    </SegmentedToggle.Button>,
    <SegmentedToggle.Button key="2" value="option2">
      Option
    </SegmentedToggle.Button>,
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SegmentedToggleProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
